/** 官网静态数据 */
export const slogan = '花小二｜AI智能园艺全链路服务商'

export const swiperList = [
  {
    img: require('@/assets/img/banner001.jpg'),
    imgMobile: require('@/assets/img/web_banner001.jpg')
  },
  {
    img: require('@/assets/img/banner002.jpg'),
    imgMobile: require('@/assets/img/web_banner002.jpg')
  },
  {
    img: require('@/assets/img/banner003.jpg'),
    imgMobile: require('@/assets/img/web_banner003.jpg')
  },
  {
    img: require('@/assets/img/banner004.jpg'),
    imgMobile: require('@/assets/img/web_banner004.jpg')
  }
]

export const copyrightList = [
  { name: '花卉养护管理软件 V1.0', no: '2017SR412036', date: '2017年', img: require('@/assets/img/cert/花卉养护管理软件.jpg') },
  { name: '花卉种子仓库管理软件 V1.0', no: '—', date: '2017年', img: require('@/assets/img/cert/花卉种子仓库管理软件.jpg') },
  { name: '土壤温湿度可视化软件', no: '—', date: '2017年', img: require('@/assets/img/cert/土壤温度、水份检测可视化软件.jpg') },
  { name: 'IOS 客户端软件', no: '—', date: '2017年', img: require('@/assets/img/cert/IOS客户端软件.jpg') },
  { name: '插花艺术观赏性软件', no: '—', date: '2017年', img: require('@/assets/img/cert/插花艺术观赏性软件.jpg') },
  { name: '花卉传感器信息管理平台', no: '—', date: '2017年', img: require('@/assets/img/cert/花卉传感器信息管理平台.jpg') }
]

export const patentList = [
  { name: '基于感湿材料的土壤含水量测量装置', no: '实用新型', date: '—', img: require('@/assets/img/cert/基于感湿材料的土壤含水量测量装置.jpg') },
  { name: '基于红外热释感应测试植物温度的装置', no: '实用新型', date: '—', img: require('@/assets/img/cert/基于红外热释感应测试植物温度的装置.jpg') },
  { name: '一种二维码插杆灌溉装置', no: '实用新型', date: '—', img: require('@/assets/img/cert/一种二维码插杆灌溉装置.jpg') },
  { name: '一种可拆卸更换土壤的花盆', no: '实用新型', date: '—', img: require('@/assets/img/cert/一种可拆卸更换土壤的花盆.jpg') },
  { name: '一种折叠花盆', no: '实用新型', date: '—', img: require('@/assets/img/cert/一种折叠花盆.jpg') },
  { name: '应用于园艺种植生长环境模型', no: '实用新型', date: '—', img: require('@/assets/img/cert/应用于园艺种植生长环境模型.jpg') }
]

export const customerCategories = [
  { id: 'all', label: '全部' },
  { id: 'enterprise', label: '政企/集团' },
  { id: 'agriculture', label: '农业科研' },
  { id: 'university', label: '高校院所' }
]

export const customerList = [
  { logo: require('@/assets/img/logo/logo_qm.png'), name: '清美集团', category: 'enterprise', project: '规模化果蔬智能水肥项目' },
  { logo: require('@/assets/img/logo/logo_wk.png'), name: '万科集团', category: 'enterprise', project: '社区植物仓智能养护项目' },
  { logo: require('@/assets/img/logo/logo_shcszwy.png'), name: '上海辰山植物园', category: 'agriculture', project: '植物园智能灌溉系统' },
  { logo: require('@/assets/img/logo/logo_zgnykxy.png'), name: '中国农业科学院', category: 'agriculture', project: '农业科研物联网合作' },
  { logo: require('@/assets/img/logo/logo_jssnykxy.png'), name: '江苏省农业科学院', category: 'agriculture', project: '设施农业智能养护' },
  { logo: require('@/assets/img/logo/logo_shsnykxy.png'), name: '上海农业科学院', category: 'agriculture', project: '园艺种植环境模型研究' },
  { logo: require('@/assets/img/logo/logo_shdjxy.png'), name: '上海电机学院', category: 'university', project: '校园绿化智能养护' },
  { logo: require('@/assets/img/logo/logo_shjtdx.png'), name: '上海交通大学', category: 'university', project: '产学研合作' },
  { logo: require('@/assets/img/logo/logo_hnzwy.png'), name: '华南植物园', category: 'agriculture', project: '植物园智能养护' },
  { logo: require('@/assets/img/logo/logo_sfyy.png'), name: '上房园艺', category: 'enterprise', project: '花卉养护管理系统' },
  { logo: require('@/assets/img/logo/logo_cnst.png'), name: '初农生态', category: 'enterprise', project: '生态农业智能水肥' },
  { logo: require('@/assets/img/logo/logo_sjhfdgy.png'), name: '世界花卉大观园', category: 'agriculture', project: '花卉展示智能养护' }
]

export const caseCategories = [
  { id: 'all', label: '全部案例' },
  { id: 'base', label: '规模化果蔬基地' },
  { id: 'garden', label: '园林文旅/植物园' },
  { id: 'rooftop', label: '社区屋顶绿化' },
  { id: 'edu', label: '高校/合作社' }
]

export const customerCaseList = [
  {
    title: '白鹤草莓种植基地',
    category: 'base',
    intro: '部署土壤温湿度传感器与智能水肥系统，实现大棚精准灌溉。',
    background: '规模化草莓种植基地，需降低人工巡检与灌溉成本。',
    equipment: '智能土壤传感器、灌溉插杆、智能网关、微信小程序',
    result: '节水约 40%，人工减少约 70%',
    caseImgSrc: [require('@/assets/img/customer/bhcmzzjd_1.jpg'), require('@/assets/img/customer/bhcmzzjd_2.jpg')]
  },
  {
    title: '蓝莓缘',
    category: 'base',
    intro: '蓝莓大棚智能环境监控与自动水肥调控。',
    background: '蓝莓种植对土壤湿度敏感，需精准控水。',
    equipment: '土壤传感器、环境传感器、智能施肥控制器',
    result: '施肥精准度提升，人工成本显著下降',
    caseImgSrc: [require('@/assets/img/customer/lmy_1.jpg'), require('@/assets/img/customer/lmy_2.jpg')]
  },
  {
    title: '上海枫锦果蔬专业合作社',
    category: 'base',
    intro: '合作社连片大棚智能养护系统部署。',
    background: '多棚联合管理，需统一远程监控平台。',
    equipment: '智能网关、水肥机、PC管理后台',
    result: '多棚统一管控，管理效率提升 60%',
    caseImgSrc: [require('@/assets/img/customer/shfjgszzzyhzs_1.jpg'), require('@/assets/img/customer/shfjgszzzyhzs_2.jpg')]
  },
  {
    title: '上海辰山植物园',
    category: 'garden',
    intro: '植物园展区智能灌溉与环境监测。',
    background: '大型植物园多展区养护，需精细化分区管理。',
    equipment: '环境传感器、智能电磁阀、PC后台',
    result: '分区灌溉自动化，养护标准化',
    caseImgSrc: [require('@/assets/img/customer/shcszwy_1.png'), require('@/assets/img/customer/shcszwy_2.png')]
  },
  {
    title: '上房梦花园',
    category: 'garden',
    intro: '文旅花园景观智能养护解决方案。',
    background: '景观花卉养护需兼顾美观与节水。',
    equipment: '土壤传感器、智能灌溉系统',
    result: '景观品质稳定，用水量优化',
    caseImgSrc: [require('@/assets/img/customer/sfmhy_1.jpg'), require('@/assets/img/customer/sfmhy_2.jpg')]
  },
  {
    title: '园科所花卉',
    category: 'garden',
    intro: '科研花卉种植环境数据采集与分析。',
    background: '花卉科研需精准记录生长环境数据。',
    equipment: '多维度传感器、数据可视化平台',
    result: '环境数据可追溯，科研效率提升',
    caseImgSrc: [require('@/assets/img/customer/ykshh_1.jpg'), require('@/assets/img/customer/ykshh_2.jpg')]
  },
  {
    title: '上海市小区屋顶菜园',
    category: 'rooftop',
    intro: '社区屋顶菜园轻量化智能养护部署。',
    background: '屋顶种植空间有限，需简易远程管理。',
    equipment: '微型传感器、小程序操控',
    result: '居民可手机远程浇水，参与率提升',
    caseImgSrc: [require('@/assets/img/customer/shsxqwdcy_1.jpg'), require('@/assets/img/customer/shsxqwdcy_2.jpg')]
  },
  {
    title: '万科植物仓',
    category: 'rooftop',
    intro: '社区植物仓智能养护物联网改造。',
    background: '植物仓需定时养护，减少物业人工投入。',
    equipment: '智能控制板、土壤传感器、小程序',
    result: '养护自动化，物业运维成本降低',
    caseImgSrc: [require('@/assets/img/customer/wksq_1.jpg'), require('@/assets/img/customer/wksq_2.jpg')]
  },
  {
    title: '机电学院月影桥',
    category: 'edu',
    intro: '校园绿化智能养护示范工程。',
    background: '高校校园绿化养护教学与实践结合。',
    equipment: '传感器、智能网关、养护管理平台',
    result: '绿化养护数字化示范',
    caseImgSrc: [require('@/assets/img/customer/jdxyyyq_1.jpg'), require('@/assets/img/customer/jdxyyyq_2.jpg')]
  },
  {
    title: '上海抒情花卉专业合作社',
    category: 'edu',
    intro: '合作社花卉种植智能水肥管理。',
    background: '花卉合作社需降低施肥用工。',
    equipment: '智能水肥机、土壤传感器',
    result: '施肥自动化，用工成本下降',
    caseImgSrc: [require('@/assets/img/customer/shsqhhzyhzs_1.jpg'), require('@/assets/img/customer/shsqhhzyhzs_2.jpg')]
  }
]

export const productPackages = [
  {
    name: '小型花圃套餐',
    tag: '散户/家庭',
    desc: '适合阳台、小花园，含基础传感器+小程序远程浇水',
    color: 'pkg-green',
    features: ['土壤温湿度传感器', '微信小程序操控', '基础生长模型']
  },
  {
    name: '连片果蔬基地套餐',
    tag: '合作社/基地',
    desc: '适合大棚、果蔬基地，含网关+水肥机+PC后台',
    color: 'pkg-blue',
    features: ['智能网关+水肥机', 'AI自动灌溉施肥', 'PC数据监控后台']
  },
  {
    name: '园区/屋顶绿化总包',
    tag: '政企/园区',
    desc: '适合园区绿化、屋顶菜园，含定制开发+上门勘测',
    color: 'pkg-dark',
    features: ['软硬件定制开发', '工程师上门勘测', '全链路项目总包']
  }
]

export const advantageList = [
  { logo: require('@/assets/img/tel.png'), title: '专业指导', content: '<p>7×24小时客服</p>园艺工程师一对一上门勘测' },
  { logo: require('@/assets/img/computer.png'), title: '落地易用', content: '<p>微信小程序零部署</p>10分钟完成设备联网调试' },
  { logo: require('@/assets/img/qq.png'), title: '售后保障', content: '<p>全国上门维保</p>远程视频实时故障排查' },
  { logo: require('@/assets/img/skill.png'), title: '技术实力', content: '<p>6项专利+6项软著</p>自研AI水肥算法，2017年起技术沉淀' }
]

export const plantScenes = ['大棚种植', '屋顶/阳台菜园', '果蔬基地', '园林绿化', '政企园区', '其他']



// WEBPACK FOOTER //
// ./src/data/siteData.js